import React, { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useWindowSize } from "api/commonConstants";
import { getLanguage } from "localization/i8intl";
import { NextSeo } from "next-seo";
import Head from "next/head";
import { useRouter } from "next/router";
import { MasterConfigContext } from "constants/MasterConfigContext";
import { baseUrl } from "api/constants";
import { stateData } from "../../../../constants/state";
import Tally from "components/tally/Tally";

// import { FormattedMessage } from "react-intl";

export default function Trending(props) {
  const mainUrl = "all";
  const electionsData = useContext(MasterConfigContext)?.[props.masterKey];

  console.log("Checking data", electionsData);
  var stateNameEnglish = "Maharashtra";
  var stateNameHindi = "महाराष्ट्र";
  var metaKeyMaharashtra =
    "Maharashtra Assembly Election Schedule,Maharashtra Assembly Election Schedule,Maharashtra Assembly Election 2024,Maharashtra विधान सभा चुनाव 2024,महाराष्ट्र विधान सभा चुनाव  2024,महाराष्ट्र चुनाव अनुसूची 2024";

  const [language, setLanguage] = useState("");

  const size = useWindowSize();
  const router = useRouter();
  const [electionTopicData, setElectionTopicData] = useState([]);
  useEffect(async () => {
    let dataFetched;
    const datas = await fetch(
      `${baseUrl}/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog`
    );
    dataFetched = await datas?.json();
    dataFetched = dataFetched?.result?.entities;
    setElectionTopicData(dataFetched);
  }, []);

  useEffect(() => {
    setLanguage(getLanguage());
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
              [
                [728, 90],
                [970, 250],
                [970, 90],
              ],
              "div-gpt-ad-1701945163318-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
              [728, 90],
              "div-gpt-ad-1701945220410-1"
            )
            .addService(googletag.pubads());

          //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
              [
                [336, 280],
                [300, 250],
              ],
              "div-gpt-ad-1701946028239-1"
            )
            .addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      }
      googletag.pubads().refresh();
      // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []);
  return (
    <>
      <Head>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org/",
              "@type": "WebPage",
              name: `${stateNameEnglish} Assembly Election 2024 Schedule: ${stateNameHindi} विधान सभा चुनाव अनुसूची`,
              description: `${stateNameEnglish} Vidhan Sabha Chunav 2024 Schedule : Find here all details related to ${stateNameEnglish} Assembly Elections 2024 Schedule (विधानसभा चुनाव 2024 अनुसूची) like poll dates,
                key candidates, election result date at The Lallantop`,
              keywords: `${metaKeyMaharashtra}`,
              url: `${process.env.NEXT_PUBLIC_BASE_URL}/election/maharashtra-assembly-chunav/schedule`,
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                url: "https://www.thelallantop.com/",
                logo: {
                  "@type": "ImageObject",
                  url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                  width: 600,
                  height: 60,
                },
              },
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}`,
                    name: `${"Home"}`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: `${"Election"}`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}election`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  item: {
                    name: `${"Assembly Election 2024"}`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}election/maharashtra-assembly-chunav`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 4,
                  item: {
                    name: `${
                      props?.state === "maharashtra"
                        ? "Maharashtra Assembly Election 2024 Schedule"
                        : "Jammu and Kashmir Assembly Election 2024 Schedule"
                    }`,
                    "@id": `${process.env.NEXT_PUBLIC_BASE_URL}/election/maharashtra-assembly-chunav/schedule`,
                  },
                },
              ],
            }),
          }}
        ></script>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SiteNavigationElement",
              name: [
                "होम",
                "चुनाव",
                "न्यूज़",
                "एंटरटेनमेंट",
                "ऑडनारी",
                "टेक्नोलॉजी",
                "पड़ताल",
                "बिज़नेस",
                "लल्लनख़ास",
                "स्पोर्ट्स",
                "रंगरूट",
              ],
              url: [
                "https://www.thelallantop.com/",
                "https://www.thelallantop.com/election",
                "https://www.thelallantop.com/news",
                "https://www.thelallantop.com/entertainment",
                "https://www.thelallantop.com/oddnaari",
                "https://www.thelallantop.com/technology",
                "https://www.thelallantop.com/factcheck",
                "https://www.thelallantop.com/business",
                "https://www.thelallantop.com/lallankhas",
                "https://www.thelallantop.com/sports",
                "https://www.thelallantop.com/education",
              ],
            }),
          }}
        ></script>
        <link
          rel="preconnect"
          crossOrigin="true"
          href="https://static.chartbeat.com"
        ></link>

        <script
          async
          dangerouslySetInnerHTML={{
            __html: `
            (function () {
              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
              _sf_async_config.uid = 60355;
              _sf_async_config.domain = 'thelallantop.com';
              _sf_async_config.useCanonical = true;
              _sf_async_config.useCanonicalDomain = true;
              _sf_async_config.sections = 'home'; 
              _sf_async_config.authors = '';
              function loadChartbeat() {
                  var e = document.createElement('script');
                  var n = document.getElementsByTagName('script')[0];
                  e.type = 'text/javascript';
                  e.async = true;
                  e.src = '//static.chartbeat.com/js/chartbeat.js';
                  n.parentNode.insertBefore(e, n);
              }
              loadChartbeat();
          })();
       `,
          }}
          strategy="afterInteractive"
          id="chartbeat"
          type="text/javascript"
        ></script>
      </Head>
      <NextSeo
        title={`${stateNameEnglish} Assembly Election 2024 Schedule: ${stateNameHindi} विधान सभा चुनाव अनुसूची 

`}
        description={`${stateNameEnglish} Vidhan Sabha Chunav 2024 Schedule : Find here all details related to ${stateNameEnglish} Assembly Elections 2024 Schedule (विधानसभा चुनाव 2024 अनुसूची) like poll dates,
key candidates, election result date at The Lallantop 

`}
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}/election/maharashtra-assembly-chunav/schedule`}
      />

      <meta name="keywords" content={`${metaKeyMaharashtra}`} />
      {size.width > 500 ? (
        <div>
          {size.width >= 600 && (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {router.asPath.includes("election") && (
                <div style={{ position: "relative" }}>
                  <img
                    src={"/assets/images/election-background-3.png"}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "298px",
                    }}
                  ></img>
                  <img
                    src="/assets/images/left-election-top-2.png"
                    width=""
                    height="170px"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                    }}
                  ></img>
                  <img
                    src={
                      router.asPath.includes("maharashtra-assembly")
                        ? "/assets/images/right-election-top-2.png"
                        : router.asPath.includes("jammu-kashmir-assembly")
                        ? "/assets/images/jammu-kashmir.png"
                        : "/assets/images/indian-map.png"
                    }
                    width=""
                    height="250px"
                    style={{ position: "absolute", bottom: "0", right: "0px" }}
                  ></img>
                </div>
              )}
              <Container
                align="center"
                style={{
                  position: router.asPath.includes("/election")
                    ? "absolute"
                    : "relative",
                  top: router.asPath.includes("/election") ? "22px" : "0px",
                }}
              >
                {/* <Ads
          adName={"/1007232/Lallantop_ROS_728x90_300x250"}
          keyBindings={{
            category: [router.query?.categoryName],
            keywords: metaTags[category]?.metaKeyword,
          }}
        /> */}

                <div className="container-row py-2" align="center">
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#b7b7b7",
                      textAlign: "center",
                      marginBottom: "0px",
                    }}
                  >
                    Advertisement
                  </p>
                  <div
                    id="div-gpt-ad-1701945163318-0"
                    style={{
                      minWidth: "300px",
                      minHeight: "100px",
                      display: "block !important",
                      alignContent: "center",
                      textAlign: "-webkit-center",
                    }}
                    className="ads-auto-resize"
                  >
                    <script
                      type="text/javascript"
                      dangerouslySetInnerHTML={{
                        __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})`,
                      }}
                    ></script>
                  </div>
                </div>
              </Container>
            </div>
          )}
        </div>
      ) : (
        <div style={{ position: "relative", width: "100%" }}>
          <img
            src={"/assets/images/election-background-mobile.png"}
            style={{ position: "relative", width: "100%", height: "auto" }}
          ></img>
          <img
            src="/assets/images/election-left-mobile.png"
            width=""
            height="70px"
            style={{ position: "absolute", bottom: "10px", left: "10px" }}
          ></img>
          <img
            src={
              router.asPath.includes("maharashtra-assembly")
                ? "/assets/images/right-election-top-2.png"
                : router.asPath.includes("jammu-kashmir-assembly")
                ? "/assets/images/jammu-kashmir.png"
                : "/assets/images/indian-map.png"
            }
            width=""
            height="90px"
            style={{ position: "absolute", bottom: "0", right: "0px" }}
          ></img>
        </div>
      )}
      {size.width > 768 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "white",
            width: "max-content",
            margin: "auto",
            gap: "68px",
            height: "80px",
            marginTop: "15px",
            borderRadius: "12px",
            padding: "0px 30px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              // paddingTop: "1rem",
              gap: "8px",
              // cursor: "pointer",
              backgroundColor: "white",
              paddingLeft: "0px",
            }}
            // onClick={() =>
            //   window.open("/election/lok-sabha-chunav-2024", "_self")
            // }
          >
            {/* <div
              style={{ fontSize: "35px", fontWeight: "700", color: "white" }}
            >
              चुनाव
            </div> */}
            <img
              src="/assets/images/assembly-chunav.png"
              width="408.56px"
              height="58.21px"
              style={{ alignSelf: "center" }}
            ></img>
          </div>
          <div
            class="divCategoriesSchedule2 snipcss-eqdpv"
            style={{
              margin: "0px 0px",
              // backgroundColor: "rgb(217, 54, 139)",
              paddingLeft: "15px",
              alignContent: "center",
            }}
          >
            {/* {!router.asPath.includes("jammu-kashmir-assembly") && (
              <a href={`/election/haryana-assembly-chunav/results`}>
                <span>कौन जीता-कौन हारा</span>
              </a>
            )}
             {electionsData?.vidhansabha_election?.keyCandidate && <a href={`${
                    "/election/haryana-assembly-chunav/key-candidates"
                  }`}>
                  <span>प्रमुख उम्मीदवार</span>
                </a>}
            {electionsData?.vidhansabha_election?.electionExitPollToggle &&
              !router.asPath.includes("jammu-kashmir-assembly") && (
                <a href={`/election/haryana-assembly-chunav/exit-poll`}>
                  <span>एग्जिट पोल</span>
                </a>
              )}
            {electionsData?.vidhansabha_election?.electionExitPollToggle &&
              !router.asPath.includes("jammu-kashmir-assembly") && (
                <a
                  href={`/election/haryana-assembly-chunav/party-wise-result`}
                >
                  <span>विधान सभा रिजल्ट</span>
                </a>
              )} */}
            {/* )} */}

            {props.breadCrump.map((item, index) => {
              return electionsData[item.keyToShow] != false ? (
                <a key={index} href={item.url}>
                  <span>{item.displayText}</span>
                </a>
              ) : null;
            })}
            {/* {electionsData?.Maharashtra_vidhansabha_election?.MaharashtraSchedulePage &&  <a href={`/election/maharashtra-assembly-chunav/schedule`}>
              <span>शेड्यूल</span>
            </a>}
          {electionsData?.Maharashtra_vidhansabha_election?.MaharashtraSchedulePage &&  <a href={"/election/assembly-chunav/faq"}>
              <span>सामान्य प्रश्न</span>
            </a>
           } */}
          </div>
        </div>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "1rem",
              gap: "8px",
              // cursor: "pointer",
              paddingBottom: "1rem",
              backgroundColor: "white",
              marginTop: "10px",
            }}
            // onClick={() =>
            //   window.open("/election/lok-sabha-chunav-2024", "_self")
            // }
          >
            <img
              src="/assets/images/assembly-chunav.png"
              width="240px"
              height="auto"
              style={{ alignSelf: "center" }}
            ></img>
          </div>
          <div
            class="divCategoriesSchedule2 snipcss-eqdpv"
            style={{
              margin: "-1px 0px",
              backgroundColor: "white",
              paddingLeft: "15px",
              paddingBottom: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* {!router.asPath.includes("jammu-kashmir-assembly") && (
              <a href={`/election/haryana-assembly-chunav/results`}>
                <span>कौन जीता-कौन हारा</span>
              </a>
            )}
            {electionsData?.vidhansabha_election?.keyCandidate && <a href={`${
                     "/election/haryana-assembly-chunav/key-candidates"
                  }`}>
                  <span>प्रमुख उम्मीदवार</span>
                </a>}
            {electionsData?.vidhansabha_election?.electionExitPollToggle &&
              !router.asPath.includes("jammu-kashmir-assembly") && (
                <a href={`/election/haryana-assembly-chunav/exit-poll`}>
                  <span>एग्जिट पोल</span>
                </a>
              )}
            {electionsData?.vidhansabha_election?.electionExitPollToggle &&
              !router.asPath.includes("jammu-kashmir-assembly") && (
                <a
                  href={`/election/haryana-assembly-chunav/party-wise-result`}
                >
                  <span>विधान सभा रिजल्ट</span>
                </a>
              )} */}
            {/* )} */}

            {props.breadCrump.map((item, index) => {
              return electionsData[item.keyToShow] != false ? (
                <a key={index} href={item.url}>
                  <span>{item.displayText}</span>
                </a>
              ) : null;
            })}
            {/* {electionsData?.Maharashtra_vidhansabha_election?.MaharashtraSchedulePage &&  <a href={`/election/maharashtra-assembly-chunav/schedule`}>
              <span>शेड्यूल</span>
            </a>}
          {electionsData?.Maharashtra_vidhansabha_election?.MaharashtraSchedulePage &&  <a href={"/election/assembly-chunav/faq"}>
              <span>सामान्य प्रश्न</span>
            </a>} */}
          </div>
        </div>
      )}
      <br></br>
      {size.width <= 768 && (
        <div className="container-row py-2" align="center">
          <p
            style={{
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px",
            }}
          >
            Advertisement
          </p>
          <div
            id="div-gpt-ad-1701946028239-0"
            style={{
              minWidth: "300px",
              minHeight: "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center",
            }}
            className="ads-auto-resize"
          >
            <script
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
              }}
            ></script>
          </div>
        </div>
      )}

      <Tally stateName={"maharashtra"} masterConfig={electionsData} />

      {/* {electionsData?.vidhansabha_election.HRExittally && (
            <>
            {size.width < 768 ? <div className="result-page">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा एग्ज़िट पोल
              </h2>
              <div>
                <iframe
                  src={`${electionsData?.vidhansabha_election.HRExittally_URL}`}
                  width="100%"
                  height={electionsData?.vidhansabha_election.Exitpolltally_height_mobile}
                ></iframe>
              </div>
            </div> :   <div className="result-page">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा एग्ज़िट पोल
              </h2>
              <div>
                <iframe
                  src={`${electionsData?.vidhansabha_election.HRExittally_URL}`}
                  width="100%"
                  height={electionsData?.vidhansabha_election.Exitpolltally_height_web}
                ></iframe>
              </div>
            </div>}
          
            </>
          )} */}
      {/* {electionsData?.vidhansabha_election.HRresulttally && (
            <>
            {size.width < 768 ?   <div className="result-page-big">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा रिजल्ट
              </h2>
              <div>
                <iframe
                  src={electionsData?.vidhansabha_election.HRresulttally_URL}
                  width="100%"
                  height={electionsData?.vidhansabha_election.Resulttally_height_mobile}
                ></iframe>
              </div>
            </div> :   <div className="result-page-big">
              <h2
                style={{
                  fontSize: "27px",
                  color: "#D9368B",
                  fontWeight: "800",
                }}
              >
                विधानसभा रिजल्ट
              </h2>
              <div>
                <iframe
                  src={electionsData?.vidhansabha_election.HRresulttally_URL}
                  width="100%"
                  height={electionsData?.vidhansabha_election.Resulttally_height_web}
                ></iframe>
              </div>
            </div>}
          
            </>
          )} */}

      <ul className="breadcrumb party-wise-bc">
        <li>
          <a href="/" passHref>
            <a aria-label="Lallantop Home">
              <i className="icon-cat-home"></i>
              <span>Home</span>
            </a>
          </a>
        </li>
        <li>
          <a href="/election" passHref>
            <a aria-label="Lallantop Home">
              <span>Election</span>
            </a>
          </a>
        </li>

        {
          <li>
            <span>Maharashtra Election Schedule</span>
          </li>
        }
      </ul>
      <div className="lok-sabha-main" style={{ paddingBottom: "50px" }}>
        <h1>{`महाराष्ट्र विधान सभा चुनाव 2024 अनुसूची`}</h1>

        <div className="assembly-buttons">
          <div
            onClick={() => {
              if (props?.state !== "maharashtra") {
                window.location.href =
                  "/election/maharashtra-assembly-chunav/schedule";
              }
            }}
            className={
              props?.state === "maharashtra"
                ? "assembly-buttons-btn-active"
                : "assembly-buttons-btn"
            }
          >
            महाराष्ट्र
          </div>
          <div
            onClick={() => {
              if (props?.state === "maharashtra") {
                window.location.href =
                  "/election/jharkhand-assembly-chunav/schedule";
              }
            }}
            className={
              props?.state !== "maharashtra"
                ? "assembly-buttons-btn-active"
                : "assembly-buttons-btn"
            }
          >
            झारखंड
          </div>{" "}
        </div>
        <div className="schedule-card-box-election">
          <div className="schedule-card">
            <div className="state-name">महाराष्ट्र</div>
            <ul>
              <li>
                <span>फेज</span>
                <span>फेज 1</span>
              </li>
              <li>
                <span>मतदान की तारीख :</span>
                <span>20 नवंबर 2024</span>
              </li>
              <li>
                <span>मतगणना की तारीख :</span>
                <span>23 नवंबर 2024</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="electionYatra-outer-home" style={{ width: "100% " }}>
          <div className="electionYatra-header">
            <div>
              <img
                src="/assets/images/election-icon.png"
                width="35px"
                height="35px"
                alt="election-icon"
              ></img>
              <span style={{ marginLeft: "10px" }}>विधानसभा चुनाव</span>
            </div>
            <div
              className="election-aurDekhe"
              onClick={() => router.push("/election")}
            >
              <span style={{ marginRight: "10px" }}>और देखें </span>
              <img
                src="/assets/images/arrow.png"
                width="10px"
                height="10px"
              ></img>
            </div>
          </div>
          <div className="electionYatra-columns">
            {
              <a
                className="checkMobileOrNot"
                href={`${electionTopicData[0]?.permalink}`}
              >
                <div className="electionYatra-second election-mobile">
                  <div
                    className="electionYatra-second-top"
                    style={{ position: "relative" }}
                  >
                    <img src={electionTopicData[0]?.headingImageUrl}></img>
                    <i
                      className="icon-play-circle"
                      width="500px"
                      height="500px"
                      style={{
                        color: "white",
                        position: "absolute",
                        left: "2px",
                        bottom: "-5px",
                        width: "500px",
                      }}
                    ></i>
                  </div>
                  <div className="electionYatra-second-bottom">
                    <h2>{electionTopicData[0]?.title}</h2>
                  </div>
                </div>
              </a>
            }

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {electionTopicData.slice(1).map((x, index) => {
                return (
                  <a href={`${x?.permalink}`} key={index}>
                    <div className="electionYatra-first">
                      <div className="electionYatra-first-div">
                        <div
                          style={{
                            // flex: "0 0 38%",
                            position: "relative",
                            justifyContent: "center",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={x?.headingImageUrl}
                            width="160px"
                            height="90px"
                          ></img>
                          <i
                            className="icon-play-circle"
                            style={{
                              color: "white",
                              position: "absolute",
                              left: "2px",
                              bottom: "-5px",
                            }}
                          ></i>
                        </div>
                        <div
                          className="electionYatra-first-div-right"
                          style={{ flex: "0 0 60%" }}
                        >
                          <div>
                            <div
                              style={{
                                overflow: "hidden",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  lineHeight: "22px",
                                  WebkitLineClamp: "3",
                                  WebkitBoxOrient: "vertical",
                                  marginTop: "5px",
                                }}
                                className="chunav-yatra-small-title"
                              >
                                {x?.title}
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "1rem",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>

            {
              <a
                style={{ width: "100%" }}
                className="checkDesktopOrNot"
                href={`${electionTopicData[0]?.permalink}`}
              >
                <div className="electionYatra-second election-desktop">
                  <div
                    className="electionYatra-second-top"
                    style={{ position: "relative" }}
                  >
                    <img src={electionTopicData[0]?.headingImageUrl}></img>
                    <i
                      className="icon-play-circle"
                      width="500px"
                      height="500px"
                      style={{
                        color: "white",
                        position: "absolute",
                        left: "2px",
                        bottom: "-5px",
                        width: "500px",
                      }}
                    ></i>
                  </div>
                  <div className="electionYatra-second-bottom">
                    <h2>{electionTopicData[0]?.title}</h2>
                  </div>
                </div>
              </a>
            }
          </div>
        </div>
      </div>

      <Container align="center">
        <div className="container-row py-2" align="center">
          <p
            style={{
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px",
            }}
          >
            Advertisement
          </p>
          <div
            id={
              size.width > 600
                ? "div-gpt-ad-1701945220410-1"
                : "div-gpt-ad-1701946028239-1"
            }
            style={{
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center",
            }}
          >
            <script
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html:
                  size.width > 600
                    ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})`
                    : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
              }}
            ></script>
          </div>
        </div>{" "}
      </Container>
    </>
  );
}

export async function getServerSideProps(ctx) {
  let state = "maharashtra";
  const electionState = "maharashtra-assembly-chunav";

  //making state dynamic based on the election state
  // const state = stateData[electionState]['schedule']['state']
  //   const propData  = stateData[electionState]['schedule']
  const masterKey = stateData[electionState]["masterConfigKey"];
  const breadCrump = stateData[electionState]["breadCrump"];

  try {
    ctx?.res?.setHeader("Cache-Control", `max-age=120, stale-if-error=86400`);
  } catch (error) {
    console.error("cache error", error);
  }
  return {
    props: {
      // session,
      state,
      breadCrump,
      masterKey,
    }, // will be passed to the page component as props
  };
}
